export const COMPANY = {
  name: 'TowerEdge',
  fullName: 'TowerEdge Engineering Consultants',
  year: 2024,
  phone: '+91-9703030996',
  email: 'info@toweredgeconsultants.com',
  linkedIn: 'https://linkedin.com/company/toweredge-engineering-consultants',
  address: '#9, 2nd Floor Vinayagar Trade Centre, VIP Road, CBM Compound, Visakhapatnam, Andhra Pradesh, 530003, IN',
  corporateAddress:
    '#9, 2nd Floor Vinayagar Trade Centre, VIP Road, CBM Compound, Visakhapatnam, Andhra Pradesh, 530003, IN',
  registeredAddress:
    'Flat No TF-1, Malathi Krishna Residency, NGGOS Colony, Abid Nagar, Akkayyapalem, Visakhapatnam, Andhra Pradesh, 530016, IN',
  founder: 'Katari Kanaka Chaitanya',
  foundingYear: 2024,
  tagline: 'Engineered by Precision · Delivered with Excellence',
  teamSizeLabel: '20+ professionals',

  affiliation: {
    name: 'Ontivity LLC',
    url: 'https://www.ontivity.com/',
    statement:
      'TowerEdge Engineering Consultants is affiliated with Ontivity, a leading U.S based telecommunications infrastructure company.',
  },
};

// Hero Section
export const HERO = {
  eyebrow: 'Telecom Infrastructure Engineering',
  title: 'Engineering the Infrastructure Behind Connectivity',
  subtitle:
    'Building the foundation for tomorrow\'s connectivity through engineering innovation and strategic telecom deployment expertise.',
  quote: '"With a focus on excellence, we build more than just structures — we build the future of connectivity."',
  quoteAuthor: `${COMPANY.founder} | Founder & MD`,
  primaryCta: { label: 'Explore Projects', sectionId: 'gallery' },
};

// Services Section
export const SERVICES_SECTION = {
  title: 'Services',
  subtitle:
    'End-to-End Telecom Infrastructure Solutions, Guiding Every Project from Planning and Site Acquisition to Engineering, Deployment, and Successful Execution',
};

// Navigation Links (ordered to match page scroll)
export const NAV_LINKS = [
  { label: 'Home', sectionId: 'home' },
  { label: 'About Us', sectionId: 'aboutus' },
  { label: 'Services', sectionId: 'services' },
  { label: 'Team', sectionId: 'team' },
  { label: 'Gallery', sectionId: 'gallery' },
  { label: 'Contact us', sectionId: 'contactus', isCta: true },
];

// Leadership / Team Section
export const TEAM = {
  eyebrow: 'Leadership',
  title: 'The Visionaries Driving Our Mission Forward.',
  subtitle:
    'Meet the people steering TowerEdge’s strategy, delivery, and client partnerships across every project we take on.',
  members: [
    {
      id: '01',
      name: 'Kanaka Chaitanya Katari',
      role: 'Managing Director',
      quote: 'Building the foundation for tomorrow\'s connected world by inspiring innovation, strengthening partnerships, and driving sustainable growth across every stage of development.',
      image: '/images/team/chaitanya.png',
      email: 'info@toweredgeconsultants.com',
      linkedIn: 'https://www.linkedin.com/in/katari-kanaka-chaitanya',
    },
    {
      id: '02',
      name: 'Jeevan Kumar Dhindi',
      role: 'Manager, Professional Services',
      quote: 'Dedicated to aligning people, processes, and priorities to deliver meaningful outcomes, strengthen client relationships, and support long-term organizational success.',
      image: '/images/team/JEEVAN.png',
      email: 'info@toweredgeconsultants.com',
      linkedIn: 'https://www.linkedin.com/in/jeevan-dhindi-8220a6120',
    },
    {
      id: '03',
      name: 'Divya Mandala',
      role: 'Contracts Manager',
      quote: 'Driven by a passion for collaboration and continuous improvement, working closely with stakeholders to create solutions that support long-term success and sustainable growth.',
      image: '/images/team/Divya.png',
      email: 'info@toweredgeconsultants.com',
      linkedIn: 'https://www.linkedin.com/in/divya-mandala',
    },
  ],
};

// Services Data - Imported from dedicated services module
export { SERVICES } from './services';

// About Section
export const ABOUT = {
  eyebrow: 'About Us',
  title: 'Engineering Reliable Connections.',
  titleAccentLead: 'Building a',
  titleAccentHighlight: 'Stronger Future',
  description:
    'At TowerEdge, we deliver innovative and sustainable telecom infrastructure solutions tailored to the diverse needs of our clients. With expertise in structural and civil engineering for telecom, we focus on safety, efficiency, and long-term value.',
  // Short feature pillars shown alongside the intro copy.
  pillars: [
    {
      title: 'Precision & Reliability',
      description: 'Every project is delivered with precision, reliability, and strict compliance.',
    },
    {
      title: 'Expert Team',
      description: `${COMPANY.teamSizeLabel} delivering end-to-end telecom infrastructure solutions.`,
    },
    {
      title: 'End-to-End Solutions',
      description: 'From planning to execution, we ensure quality at every stage.',
    },
  ],
  establishedBadge: {
    label: 'Established in',
    year: COMPANY.foundingYear,
    description: 'Setting new standards in telecom infrastructure through precision and reliability.',
  },
  mission: {
    eyebrow: 'Our Mission',
    title: 'Shaping the Future',
    description:
      'To shape the future of telecommunications with trusted expertise and a commitment to quality in every structure we build.',
  },
  vision: {
    eyebrow: 'Our Vision',
    title: 'Leading with Innovation',
    description:
      'To be a trusted leader in delivering innovative and reliable engineering solutions in telecom and beyond.',
  },
  coreValues: {
    eyebrow: 'Our Values',
    title: 'Integrity. Excellence. Collaboration.',
    description:
      'We are committed to upholding integrity, pursuing excellence, and fostering collaboration to drive sustainable success and build lasting relationships.',
  },
  teamCapacity:
    'With a multidisciplinary team of 20+ professionals spanning design, engineering, project management, and administrative support, we provide end-to-end telecom infrastructure, operational, and professional services that empower telecom organizations to achieve their business objectives through efficient execution, operational excellence, and innovative solutions.',
};

// Contact Section
export const CONTACT = {
  eyebrow: 'Get in touch',
  title: "Let's Build the Next Generation of Infrastructure",
  subtitle:
    'Whether you\'re planning your next telecom infrastructure project or looking to build your career with TowerEdge, we\'re ready to connect. Share your requirements or resume, and our team will get back to you as soon as possible.',
  locations: [
    {
      title: 'India',
      lines: ['Visakhapatnam (Headquarters)'],
    },
    {
      title: 'United States',
      lines: ['Delivering Projects across USA'],
    },
  ],
};

// Contact Form Messages
export const FORM_MESSAGES = {
  tabs: {
    project: 'Project Enquiry',
    career: 'Careers',
  },
  namePlaceholder: 'Your name',
  companyPlaceholder: 'Company name',
  emailPlaceholder: 'you@company.com',
  careerEmailPlaceholder: 'you@gmail.com',
  // Format hint derived from the real company number, e.g. "+91 97030 30996" —
  // not a made-up example number.
  phonePlaceholder: `${COMPANY.phone.slice(0, 3)} ${COMPANY.phone.slice(4, 9)} ${COMPANY.phone.slice(9)}`,
  messagePlaceholder: 'Tell us about your project…',
  careerMessagePlaceholder: 'Tell us about yourself and the role you’re interested in…',
  resumeLabel: 'Resume / CV',
  resumeHint: 'PDF or Word, up to 8 MB',
  attachmentLabel: 'Attachment (optional)',
  attachmentHint: 'RFP, drawings, or specs — PDF, Word, or image, up to 8 MB',
  submitButton: 'Send message',
  submitButtonCareer: 'Submit application',
  nameLabelAriaLabel: 'Enter your full name',
  companyLabelAriaLabel: 'Enter your company name',
  emailLabelAriaLabel: 'Enter your email address',
  phoneLabelAriaLabel: 'Enter your phone number',
  messageLabelAriaLabel: 'Enter your message or inquiry',
  resumeLabelAriaLabel: 'Upload your resume or CV',
  attachmentLabelAriaLabel: 'Upload an optional attachment',
};

// Logo tagline (animated text under wordmark image)
// Logo tagline — two lines shown one at a time
export const LOGO_TAGLINE = {
  loop: ['ENGINEERED BY PRECISION', 'DELIVERED WITH EXCELLENCE'],
};

// Image Assets
export const IMAGES = {
  logo: '/images/brand/towerEdge1.png',
  logoIcon: '/images/brand/towerEdge-icon.png',
  logoWordmark: '/images/brand/towerEdge-wordmark.png',
  logoMark: '/images/brand/towerEdge-mark.png',
  footerLogo: '/images/brand/towerEdge1.png',
  coverPhoto: '/images/hero/CoverPhoto.jpg',
  aboutUs: '/images/about/AboutUs.jpg',
  iconMission: '/images/about/mission.png',
  iconVision: '/images/about/vision.png',
  iconTeam: '/images/about/team.png',
  iconPhone: '/images/icons/call.png',
  iconLinkedIn: '/images/icons/linkedin.png',
  iconEmail: '/images/icons/email.png',
  ontivityLogo: '/images/partners/ontivity-logo.png',
  aboutUsWordmark: '/images/brand/ToweredgeLogo2.png',
};

// Gallery Section
export const GALLERY = {
  eyebrow: 'Our Work',
  title: 'Project Gallery',
  subtitle: 'Engineering excellence across towers, sites, and telecom infrastructure.',
  images: [
    { src: '/images/gallery/carousel1.jpg', label: 'Tower deployment' },
    { src: '/images/gallery/carousel2.jpg', label: 'Structural engineering' },
    { src: '/images/gallery/carousel3.jpg', label: 'Site development' },
    { src: '/images/gallery/carousel4.jpg', label: 'Network infrastructure' },
    { src: '/images/gallery/carousel5.jpg', label: 'Field operations' },
  ],
};

// Animation Settings
export const ANIMATIONS = {
  fadeInDuration: 0.8,
  slideUpDuration: 0.8,
  staggerDelay: 0.3,
  carouselDelay: 2000,
};

// Responsive Breakpoints (Tailwind)
export const BREAKPOINTS = {
  mobile: 320,
  largeMobile: 481,
  tablet: 768,
  laptop: 1024,
  desktop: 1440,
};

